module.exports = __webpack_public_path__ + "img/bg-1.75934104.jpg";